import { useTranslation } from "_metronic/i18n/language";
import {
  CampaignType,
  getAllCampaigns,
  updateCampaignOnDevice,
  updateDeviceById,
} from "app/crud";
import { MakeGetDeviceType, makeGetDevice } from "app/factories";
import Loading from "app/pages/home/components/Loading";
import FormActions from "components/FormActions";
import React, { useEffect, useState } from "react";
import { Form, Row } from "react-bootstrap";
import { FieldValues, SubmitHandler, useForm } from "react-hook-form";
import { useHistory, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { FormInput } from "../Users/components/FormInput";
import { Wrapper } from "../Users/components/Wrapper";
import { SelectCampaigns } from "./components/SelectCampaigns";

type ParamsType = {
  macAddress?: string;
};

export type CampaignIdType = {
  campaignId: number;
  isDisplay: boolean;
  remainingTests: number;
  isConfigured: boolean;
};

export const CAMPAIGN_ID_FIELD = "campaignId";
export const IS_DISPLAY_FIELD = "isDisplay";
export const IS_CONFIGURED_FIELD = "isConfigured";
export const IS_REMAINING_TESTS_FIELD = "remainingTests";

const DeviceUpdate: React.FC = () => {
  const [device, setDevice] = useState({} as MakeGetDeviceType);
  const [campaign, setCampaign] = useState<CampaignType[]>([]);
  const [loading, setLoading] = useState(true);

  const translate = useTranslation();
  const history = useHistory();
  const { macAddress } = useParams<ParamsType>();

  const { register, handleSubmit, setValue, watch } = useForm<CampaignIdType>();

  if (!macAddress) {
    return <div>DEVICE NÃO ENCONTRADO</div>;
  }

  useEffect(() => {
    const start = async () => {
      const data = await makeGetDevice(macAddress);
      setDevice(data);
      setValue(CAMPAIGN_ID_FIELD, data.campaignId);
      setValue(IS_DISPLAY_FIELD, data.isDisplay);
      setValue(IS_CONFIGURED_FIELD, data.isConfigured);
      setValue(IS_REMAINING_TESTS_FIELD, data.remainingTests);
      setLoading(false);
    };
    getAllCampaigns().then(data => {
      setCampaign(data);
    });
    start();
  }, []);

  const onSubmit: SubmitHandler<FieldValues> = async data => {
    setLoading(true);
    try {
      const success = await updateCampaignOnDevice(
        device?.deviceId,
        data.campaignId,
      );
      const success2 = await updateDeviceById(device?.deviceId, {
        isDisplay: data.isDisplay,
        isConfigured: data.isConfigured,
        remainingTests: data.remainingTests,
      });
      if (!success) {
        throw new Error();
      }
      if (!success2) {
        Swal.fire(
          translate("defaultMessages.error"),
          translate("screens_device_errors_display"),
          "error",
        );
        throw new Error();
      }
      Swal.fire({
        title: translate("defaultMessages.success"),
        text: translate("crudMessages.successText"),
        icon: "success",
      }).then(result => {
        if (result.isConfirmed) {
          history.push("/admin/devices");
        }
      });
    } catch (e) {
      Swal.fire(
        translate("defaultMessages.error"),
        translate("screens_device_errors_register"),
        "error",
      );
    } finally {
      setLoading(false);
    }
  };

  const isDisplayValue = watch(IS_DISPLAY_FIELD);
  const isConfiguredValue = watch(IS_CONFIGURED_FIELD);
  const isRemainingTests = watch(IS_REMAINING_TESTS_FIELD);

  return (
    <div>
      <Wrapper className="card-form">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="card-body">
            <Row>
              <FormInput
                label={translate("screens_device_labels_macAddress")}
                name="macAdress"
                placeholder={device?.macAddress}
                className="col-lg-4"
                disable={true}
              />
              <SelectCampaigns
                className="form-select"
                data={campaign}
                register={register}
              />
              <FormInput
                label={translate("screens_device_labels_user")}
                name="deviceUser"
                placeholder={device?.connectedUser}
                className="col-lg-4"
                disable={true}
              />
            </Row>
            <Row>
              <FormInput
                label={translate("screens_device_labels_owner")}
                name="deviceOwner"
                placeholder={device?.ownerName}
                className="col-lg-4"
                disable={true}
              />
              <div className="col-lg-4 col-12">
                <Form.Check
                  style={{ marginTop: 20 }}
                  type="checkbox"
                  label={`${translate("screens_device_display_title")} ${
                    isDisplayValue
                      ? translate("screenApp_modal_yes")
                      : translate("screenApp_modal_no")
                  }`}
                  {...register(IS_DISPLAY_FIELD)}
                  checked={isDisplayValue}
                  onChange={event =>
                    setValue(IS_DISPLAY_FIELD, event.target.checked)
                  }
                />
              </div>
              <div className="col-lg-4 col-12">
                <Form.Check
                  style={{ marginTop: 20 }}
                  type="checkbox"
                  label={`${translate("screens_device_is_configured")} ${
                    isConfiguredValue
                      ? translate("screenApp_modal_yes")
                      : translate("screenApp_modal_no")
                  }`}
                  {...register(IS_CONFIGURED_FIELD)}
                  checked={isConfiguredValue}
                  onChange={event =>
                    setValue(IS_CONFIGURED_FIELD, event.target.checked)
                  }
                />
              </div>
            </Row>
            <Row>
              <FormInput
                label={translate("screens_device_remaining_tests")}
                name="remainingTests"
                className="col-lg-4"
                // disable={true}
                value={isRemainingTests | 0}
                type="number"
                onChange={event =>
                  setValue(IS_REMAINING_TESTS_FIELD, Number(event.target.value))
                }
              />
            </Row>
          </div>
          <FormActions module="devices" onReset={() => null} />
        </form>
      </Wrapper>
      <Loading isLoading={loading} />
    </div>
  );
};
export default DeviceUpdate;
